"use strict";
import f1 from "@eab-pip/pi-f1";
export class STCCSRFToken {
  constructor() {
    this.id = "api-authorization-csrf-token";
    this.type = "request";
  }
  async invoke(infoIO) {
    const options = f1.read("/options", "", infoIO);
    const authorizationType = f1.read("/authorization/type", "", options);
    if (authorizationType === "csrf") {
      const headers = f1.read("/packet/headers", {}, infoIO);
      const authorizationKey = `X-CSRF-TOKEN`;
      const authorizationValue = document.querySelector('meta[name="csrf-token"]').getAttribute("content");
      headers[authorizationKey] = authorizationValue;
      return f1.write("/packet/headers", headers, infoIO);
    }
    return infoIO;
  }
}
export const stcCSRFInterceptor = new STCCSRFToken();
export class STCFormCSRFToken {
  constructor() {
    this.id = "api-form-authorization-csrf-token";
    this.type = "request";
  }
  async invoke(infoIO) {
    const headers = f1.read("/packet/headers", {}, infoIO);
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");
    const newHeader = f1.merge("over", headers, {
      ...csrfToken && { "X-CSRF-TOKEN": csrfToken }
    });
    return f1.write("/packet/headers", newHeader, infoIO);
  }
}
export const stcFormCSRFInterceptor = new STCFormCSRFToken();
